import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatRadioModule} from '@angular/material/radio';
import { MatSelectFilterModule } from 'mat-select-filter';
import { ConversationLogSimpleComponent } from './conversation-log-simple.component';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MatSelectModule} from '@angular/material/select';

declare var require: any;

@NgModule({
  declarations: [ConversationLogSimpleComponent],
  imports: [
    CommonModule,
    FormsModule, 
    ReactiveFormsModule,
    MatSelectModule, 
    MatFormFieldModule,
    MatSelectFilterModule,
    MatRadioModule
  ],
  exports: [
    ConversationLogSimpleComponent,
  ]
})
export class ConversationLogSimpleModule { }
